/* SHARED — the dictionaries and the small pieces the notifications are drawn with */

/* Who the notification is written for */
export const TYPES = [
    { key: "client", text: "Клиенты", receivers: "клиентам" },
    { key: "master", text: "Мастера", receivers: "мастерам" }
]


/* Whether the notification has already left the panel */
export const STATES = [
    { key: 0, text: "Черновик", accent: "orange" },
    { key: 1, text: "Отправлен", accent: "blue" }
]


/* The audience of one template — the row of the list and the card both read it through this */
export const typeOf = value => {

    const found = TYPES.find(item => item.key === value)

    return found ? found : TYPES[0]
}


/* The state of one template */
export const stateOf = value => {
    return parseInt(value) === 1 ? STATES[1] : STATES[0]
}


/* The icon of a notification — it stands in place of the picture a template has none of */
export const notificationIcon = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M12 3.2a6 6 0 0 0-6 6v3.1l-1.5 3.1a.7.7 0 0 0 .6 1h13.8a.7.7 0 0 0 .6-1L18 12.3V9.2a6 6 0 0 0-6-6Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M9.6 19a2.5 2.5 0 0 0 4.8 0" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
    )
}


/* One line of the card — the name of the field and its value */
export const line = (text, value, accent = "") => {

    if (value === null || value === undefined || `${value}`.length === 0) {
        return null
    }

    return (
        <div className="nt-details-line" key={text}>
            <div className="nt-details-line-text">{text}</div>
            <div className={`nt-details-line-value ${accent}`}>{value}</div>
        </div>
    )
}
